module.exports = __webpack_public_path__ + "staticcomp/img/share.50ed2d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/14/share.jpg
// module id = vbHZ
// module chunks = 39